/**
 * Coordinates used in the {@link set-detail} component
 */
export class Coordinate {

    degrees!: number;

    minutes!: number;

    decimal!: number;

    hemisphere!: string;

    constructor() {

    }


    /**
     * 
     * @param dec Coordinate decimal form
     * @returns Coordinate object translated from dec
     */
    static fillDegrees(dec: number, hem?: string) {
        let coord = new Coordinate;
        coord.decimal = dec;
        coord.degrees = Math.floor(Math.abs(dec));
        coord.minutes = Number.parseFloat(((Math.abs(dec) - coord.degrees) * 60).toFixed(2));
        if (hem) coord.hemisphere = hem;
        return coord;
    }


    /**
     * Fills this Coordinate object's decimal field based on its degrees, minutes
     */
    fillDecimal() {
        console.log(this)
        this.decimal = (this.degrees + (this.minutes / 60)) * (this.hemisphere == 'W' || this.hemisphere == 'S' ? -1 : 1);
    }

    isUnfilled() {
        return this.degrees == undefined && this.minutes == undefined
    }

  toString() {
    return (this.degrees !== undefined && this.minutes !== undefined) ? Math.abs(this.degrees) + "\u00B0" + " " + this.minutes + "'" + (this.hemisphere !== undefined ? this.hemisphere : (this.decimal < 0 ? 'W' : 'N')) : "";
    }


    static transformAnon(anon: any) {
        let coord = new Coordinate;
        if (anon) {
            coord.decimal = anon.decimal;
            coord.degrees = anon.degrees;
            coord.minutes = anon.minutes;
            coord.hemisphere = anon.hemisphere;
        }
        return coord;
    }

}
